import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";

import { ALLOWED_MODULES } from "../../constants/enums";

const Automation = Loadable(
  lazy(() =>
    import("./AutomationList").then(({ AutomationList }) => ({
      default: AutomationList,
    }))
  )
);

const ManageAutomation = Loadable(
  lazy(() =>
    import("./ManageAutomation").then(({ ManageAutomation }) => ({
      default: ManageAutomation,
    }))
  )
);

export const automationListRoutes = [
  {
    path: "/automation",
    exact: true,
    element: (
      <AuthorizedRoute
        
        moduleIds={[ALLOWED_MODULES.AUTOMATION]}
      >
        <Automation />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/automation/manage",
    exact: true,
    element: (
      <AuthorizedRoute
        
        moduleIds={[ALLOWED_MODULES.AUTOMATION]}
      >
        <ManageAutomation />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/automation/manage/:automationCode",
    exact: true,
    element: (
      <AuthorizedRoute
        
        moduleIds={[ALLOWED_MODULES.AUTOMATION]}
      >
        <ManageAutomation />
      </AuthorizedRoute>
    ),
  },
];
